/**
 * URL-hash keys for the repair-settings feature's deep-linkable overlays,
 * bound via `useHashDialog` / `useHashParamDialog` (see
 * `@/hooks/use-hash-dialog`). Reason ids are unique across destinations, so
 * edit/delete overlays don't need the destination id as a second param.
 */
export const REPAIR_SETTINGS_HASH = {
  /** `#add-reason/<destId>` — add-reason dialog (page-level). */
  addReason: 'add-reason',
  /** `#edit-reason/<reasonId>` — edit-reason dialog (per-destination section). */
  editReason: 'edit-reason',
  /** `#delete-reason/<reasonId>` — single-reason delete confirmation. */
  deleteReason: 'delete-reason',
  /** `#bulk-delete-reasons/<destId>` — bulk-delete confirmation for a destination's reasons table. */
  bulkDeleteReasons: 'bulk-delete-reasons'
} as const;

export type RepairSettingsHashKey =
  (typeof REPAIR_SETTINGS_HASH)[keyof typeof REPAIR_SETTINGS_HASH];
